import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { withTranslation } from "react-i18next";
import Card from "src/components/blocks/Card";
import BuildButton from "src/components/elements/BuildButton";
import { Col, Grid } from "src/components/utilities/Grids";
import { theme } from "src/styles/theme";

class FolderList extends PureComponent {
  static propTypes = {
    data: PropTypes.array,
    showBuildButton: PropTypes.bool,
    editableCards: PropTypes.bool,
    author: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showSubscribeButton: PropTypes.bool,
    marginTopContainer: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  };

  static defaultProps = {
    marginTopContainer: 2,
  };

  render() {
    const {
      t,
      data,
      showBuildButton,
      editableCards,
      author,
      showSubscribeButton,
      marginTopContainer,
    } = this.props;

    return (
      <Grid mt={marginTopContainer}>
        {showBuildButton && (
          <Col width={[1 / 1, 1 / 1, 1 / 2, 1 / 3]} pb={2}>
            <BuildButton route={"/chaines/creer"} label={t("createAChain")} />
          </Col>
        )}
        {data.map((values, key) => {
          return (
            <Col key={key} width={[1 / 1, 1 / 1, 1 / 2, 1 / 3]} pb={2}>
              <Card.Folder
                {...values}
                editable={editableCards && author === values.author.id}
                showSubscribeButton={showSubscribeButton}
                contentBg={theme.colors.gray100}
              />
            </Col>
          );
        })}
      </Grid>
    );
  }
}

export default withTranslation()(FolderList);
